import { CardCollectionApplicationDto } from '~/modules/CardCollections/Application/GetCardCollectionsApplicationDto'
import { CardCollectionComponentDto } from '~/modules/CardCollections/Infrastructure/CardCollectionComponentDto'

export class CardCollectionComponentDtoTranslator {
  public static fromApplication (dto: CardCollectionApplicationDto): CardCollectionComponentDto {
    return {
      id: dto.id,
      name: dto.name,
      availableCards: dto.availableCards,
      obtainedCards: dto.obtainedCards,
      obtainableCards: dto.obtainableCards,
      organizerLogo: dto.organizerLogo,
    }
  }
}
